// @ts-nocheck
import { infoProps } from "@store/Themes/common/props/info";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import QuestionMarkCircleFill from "@toolkit/Library/Components/Icons/QuestionMarkCircle/QuestionMarkCircleFill";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            src: QuestionMarkCircleFill,
            size: 18,
            css: null as any,
        },
        cssOverrides: {
            tooltipWrapper: css`
                margin-left: ${pxToRem(5)};
                top: 0.125em;
            `,
            tooltipClickable: css`
                padding: 0;
            `,
        },
    },
};

export default tooltip;
